import React, {useState} from "react";
import { Link } from "react-router-dom";

export default function ProductCard({img,title, url}){

    const [isButtonHover, setIsButtonHover] = useState(false);

    const mainContainerStyle ={
        display: 'flex',
        justifyContent: ' flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        borderRadius: '10px',
        gap: '20px',
        height: "350px",
        backgroundColor: isButtonHover ? "#F0EFEC" : "#011a39",
        transition:'0.3s'
    }
    const imageStyle = {
        height: '200px',
        width: '300px',
        borderRadius: "10px"
    }
    const titleStyle = {
        color: isButtonHover ? "#011a39":"#fec803",
        fontFamily: 'Oswald',
        fontStyle: "bold",
        fontSize: "2rem",
        textAlign: "center",
        width: '80%',
        transition:'0.3s'
    }
    return(
        <>
            <Link style={mainContainerStyle} to={url}
                onMouseEnter={() => setIsButtonHover(true)} 
                onMouseLeave={() => setIsButtonHover(false)}>
                <img style={imageStyle} src={img}></img>
                <div style={titleStyle}>{title}</div>
            </Link>
        </>
    )
}